import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import utils from '@/utils';
import store from '@/store';
import api from '@/api';
import layoutHeaderAside from '@/layout/header-aside'; // fix vue-router NavigationDuplicated

var VueRouterPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};

var VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
};

Vue.use(VueRouter);
/**
 * @description 创建在 layout 中显示的路由设置
 * @param {Array} routes 动态路由设置
 */

export function createRoutesInLayout() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return [{
    path: '/',
    redirect: {
      name: 'index'
    },
    component: layoutHeaderAside,
    children: [{
      path: 'index',
      name: 'index',
      meta: {
        title: 'index',
        auth: true
      },
      component: utils.import('system/index')
    }, {
      path: 'log',
      name: 'log',
      meta: {
        title: 'front log',
        auth: true
      },
      component: utils.import('system/log')
    }, {
      path: 'sms-recharge',
      name: 'sms-recharge',
      meta: {
        title: 'sms recharge'
      },
      component: utils.import('management/sms-recharge/index.vue')
    }, {
      path: 'device-recharge',
      name: 'device-recharge',
      meta: {
        title: 'device-recharge'
      },
      component: utils.import('management/device-recharge/index.vue')
    }, {
      path: 'management-xufei',
      name: 'management-xufei',
      meta: {
        title: 'device recharge'
      },
      component: utils.import('management/xufei')
    }].concat(_toConsumableArray(routes))
  }];
} // 在 layout 之外显示的路由

export var routesOutLayout = [{
  path: '/refresh',
  name: 'refresh',
  component: utils.import('system/function/refresh'),
  hidden: true
}, {
  path: '/redirect/:route*',
  name: 'redirect',
  component: utils.import('system/function/redirect'),
  hidden: true
}, {
  path: '/login',
  name: 'login',
  component: utils.import('system/login'),
  hidden: true
}, {
  path: '*',
  name: '404',
  component: utils.import('system/error/404'),
  hidden: true
}]; // 默认的路由

export var constantRoutes = createRoutesInLayout().concat(routesOutLayout);
/**
 * @description 创建路由
 * @param {Array} routes 路由设置
 */

var createRouter = function createRouter() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new VueRouter({
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: routes
  });
}; // 导出路由 在 main.js 里使用


var router = createRouter(constantRoutes);
/**
 * @description 重新设置路由
 * @param {Array} routes 额外追加的路由
 */

export function resetRouter() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  router.matcher = createRouter(routes).matcher;
}
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            NProgress.start();
            _context.prev = 1;
            // 关闭搜索面板
            store.commit('d2admin/search/set', false); // 确认已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201

            _context.next = 5;
            return store.dispatch('d2admin/page/isLoaded');

          case 5:
            _context.next = 7;
            return store.dispatch('d2admin/size/isLoaded');

          case 7:
            _context.next = 9;
            return store.dispatch('d2admin/permission/load', {
              to: to.fullPath
            });

          case 9:
            if (!to.matched.some(function (r) {
              return r.meta.auth;
            })) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return api.USER_CHECK_TOKEN();

          case 12:
            next();
            _context.next = 16;
            break;

          case 15:
            next();

          case 16:
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            next(false);

          case 21:
            NProgress.done();

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done(); // 多页控制 打开新的页面

  store.dispatch('d2admin/page/open', to); // 更改标题

  utils.title(to.meta.title);
});
export default router;